import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const extendTrial = createAsyncThunk(
  'extendTrial',
  async (params, { rejectWithValue }) => {
    const { extraDays } = params

    const [success, response] = await httpRequest({
      url: '/api/billing/extend_trials',
      method: 'PATCH',
      data: { extra_days: extraDays }
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
